"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _csrf = require("@insided/shared/utils/csrf");

var _classnames = _interopRequireDefault(require("classnames"));

var _axios = _interopRequireDefault(require("axios"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'load-more';
exports.cssAnchorName = cssAnchorName;
var BADGES_URL_PATH = '/badges/index';
var CONTAINER_SELECTOR = '.js-load-more-container';
var PAGE_SIZE = 10;
var FIRST_LOAD_MORE_PAGE = 2;

var LoadMore = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LoadMore, _Component);

  var _super = _createSuper(LoadMore);

  function LoadMore() {
    var _this;

    (0, _classCallCheck2.default)(this, LoadMore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      page: FIRST_LOAD_MORE_PAGE,
      isLoading: false,
      hasMore: _this.props.itemCount > PAGE_SIZE
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "url", (0, _absoluteUrlRuntime.resolveUrl)(BADGES_URL_PATH));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
        var itemCount, page, _yield$axios$post, html, container, pagesTotal, nextPage, stillHasMore, _anchor$parentElement, _anchor$parentElement2, _anchor$parentElement3, anchor;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                e.stopPropagation();

                if (!(_this.state.isLoading || !_this.state.hasMore)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                itemCount = _this.props.itemCount;
                page = _this.state.page;

                _this.setState({
                  isLoading: true
                });

                _context.prev = 7;
                _context.next = 10;
                return _axios.default.post(_this.url, new URLSearchParams((0, _csrf.withCsrf)({
                  page: page,
                  itemCount: itemCount
                })));

              case 10:
                _yield$axios$post = _context.sent;
                html = _yield$axios$post.data;
                container = document.querySelector(CONTAINER_SELECTOR);
                if (container && typeof html === 'string') container.insertAdjacentHTML('beforeend', html);
                pagesTotal = Math.ceil(itemCount / PAGE_SIZE);
                nextPage = page + 1;
                stillHasMore = nextPage <= pagesTotal;

                if (!stillHasMore) {
                  anchor = _this.base;
                  anchor === null || anchor === void 0 ? void 0 : (_anchor$parentElement = anchor.parentElement) === null || _anchor$parentElement === void 0 ? void 0 : _anchor$parentElement.classList.add('is-hidden');
                  anchor === null || anchor === void 0 ? void 0 : (_anchor$parentElement2 = anchor.parentElement) === null || _anchor$parentElement2 === void 0 ? void 0 : (_anchor$parentElement3 = _anchor$parentElement2.parentElement) === null || _anchor$parentElement3 === void 0 ? void 0 : _anchor$parentElement3.classList.add('has-no-more');
                }

                _this.setState({
                  page: nextPage,
                  isLoading: false,
                  hasMore: stillHasMore
                });

                _context.next = 24;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](7);

                _this.setState({
                  isLoading: false
                });

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 21]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(LoadMore, [{
    key: "render",
    value: function render() {
      if (!this.state.hasMore) return null;
      return (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)(this.url),
        class: (0, _classnames.default)('btn--cta', 'btn--full-width', 'btn--load-more', {
          'is-loading': this.state.isLoading
        }),
        onClick: this.handleClick
      }, (0, _preact.h)(_phrase.default, {
        p: "Show more",
        renderAsText: true
      }), (0, _preact.h)("span", {
        class: "loader"
      }));
    }
  }]);
  return LoadMore;
}(_preact.Component);

exports.default = LoadMore;